import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "pb-4" }, " Detta är en endast en demo och inga faktiska personuppgifter hämtas. I produktionmiljöer så inhämtas data från Skatteverket, Bolagsverket samt Mina Ombud. ", -1)


import signinOverlay from '@/components/signin-overlay.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginView',
  props: {
  textClass: {
    type: Object
  },
  columnSizes: {
    type: Object
  }
},
  setup(__props) {

document.title = 'Logga in'

const props = __props


return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: __props.columnSizes?.[0]
        }, {
          default: _withCtx(() => [
            _createElementVNode("h1", {
              class: _normalizeClass(["my-4", __props.textClass?.h1])
            }, "Logga in till mina sidor", 2),
            _hoisted_2,
            _createVNode(signinOverlay)
          ]),
          _: 1
        }, 8, ["cols"]),
        _createVNode(_component_v_col, {
          cols: __props.columnSizes?.[1]
        }, null, 8, ["cols"])
      ]),
      _: 1
    })
  ]))
}
}

})